package com.ives.components.popup;

import js.Browser;
import com.er453r.hxcompo.Component;

class Popup extends Component{
	public static inline var CLOSE:String = "closePopup";

	private var selector:String;

	private var closeListener:Void->Void;

	public function new(content:Component) {
		on(closeButton, "click", close);

		on(CLOSE, close);

		append(content);
	}

	public function open(selector:String, ?closeListener:Void->Void){
		this.selector = selector;
		this.closeListener = closeListener;

		Browser.document.querySelector(selector).appendChild(view);
	}

	public function close(){
		on(popup, "animationend", cleanup);
		popup.classList.add("hide");

		this.viewElement.classList.add("hide");

		if(closeListener != null)
			closeListener();
	}

	private function cleanup(){
		view.remove();
	}
}
